import { 
  SET_INVOICE_LINE_FILTER_VALUE,
  EXPAND_INVOICE_LINE_FILTER,
  APPLY_INVOICE_LINE_FILTERS,
  RESTORE_INVOICE_LINE_FILTERS,
  CLEAR_ALL_INVOICE_LINE_FILTERS,
  CLEAR_INVOICE_LINE_FILTER
} from './InvoiceLinesFiltersConstants';

const expandInvoiceLineFilter = filter => ({ type: EXPAND_INVOICE_LINE_FILTER, filter });
const clearInvoiceLineFilter = filter => ({ type: CLEAR_INVOICE_LINE_FILTER, filter });
const restoreInvoiceLineFilters = () => ({ type: RESTORE_INVOICE_LINE_FILTERS });
const clearAllInvoiceLineFilters = () => ({ type: CLEAR_ALL_INVOICE_LINE_FILTERS });
const applyFiltersSuccess = () => ({ type: APPLY_INVOICE_LINE_FILTERS });
const setFilterValue = (filterKey, filterType, value) => ({ type: SET_INVOICE_LINE_FILTER_VALUE, filterKey, filterType, value });

const applyFilters = () => dispatch => dispatch(applyFiltersSuccess());

export {
  applyFilters,
  expandInvoiceLineFilter,
  clearInvoiceLineFilter,
  restoreInvoiceLineFilters,
  clearAllInvoiceLineFilters,
  setFilterValue
};


// WEBPACK FOOTER //
// ./src/redux/invoiceLinesFilters/InvoiceLinesFiltersActions.js